import { xBaseTheme } from "@eisinc/XDL/types";
import CheckboxPresentationPropsDefault from "@insite/mobius/Checkbox/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...CheckboxPresentationPropsDefault,
        css: css`
            &:hover {
                cursor: pointer;
            }

            span[role="checkbox"] {
                border-radius: 0;
                border: 2px solid ${getColor("common.ui1")};
                width: 18px;
                height: 18px;
                background: ${getColor("common.white")};

                svg {
                    width: 18px;
                    height: 18px;
                }

                &:focus {
                    outline: 2px solid ${getColor("warning.main")};
                }

                &[aria-disabled="true"] {
                    border: 2px solid ${getColor("common.ui1")};
                    background: ${getColor("common.white")};
                    cursor: not-allowed;
                    opacity: 0.5;

                    &:focus {
                        outline: 0;
                        box-shadow: none;
                    }

                    + label {
                        cursor: not-allowed;
                        opacity: 0.5;
                    }
                }
                &[aria-disabled="true"][aria-checked="true"] {
                    border: 0;
                    background: ${getColor("primary.main")};
                    color: ${getColor("common.white")};
                }

                @media print {
                    color-adjust: exact !important;
                    -webkit-print-color-adjust: exact !important;
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["checkbox"];
